import useSelector from '@app/hooks/useSelector';

import { ProjectType } from '../../../../../../../types/project';
import { getAvailableFilenames, getFileFormats, getProjectType } from '../../../../../reducers/downloadData/selectors';
import type { AvailableFileNames, FileFormat, FileFormats, Platform } from '../../../../../types';

const findPlatform = (fileFormats: FileFormats, fileFormat: FileFormat) =>
    fileFormats.flatMap(({ formats }) => formats).find(({ value }) => value === fileFormat)?.platform;

const filterAvailableFilenames = ({
    availableFilenames,
    projectType,
    platform,
    fileFormat,
    switchIncludeAll,
}: {
    availableFilenames: AvailableFileNames;
    projectType: ProjectType | undefined;
    platform: Platform | undefined;
    fileFormat: FileFormat;
    switchIncludeAll: boolean;
}) => {
    if (projectType === ProjectType.pagedDocuments) {
        return availableFilenames.filter((item) => item.format === fileFormat);
    }

    if (!switchIncludeAll) {
        return availableFilenames.filter((item) => item.device === platform);
    }

    return availableFilenames;
};

const prepareOption = ({
    availableFilenames,
    projectType,
    platform,
    fileFormat,
    switchIncludeAll,
}: {
    availableFilenames: AvailableFileNames;
    projectType: ProjectType | undefined;
    platform: Platform | undefined;
    fileFormat: FileFormat;
    switchIncludeAll: boolean;
}) =>
    filterAvailableFilenames({
        availableFilenames,
        projectType,
        platform,
        fileFormat,
        switchIncludeAll,
    }).map(({ filename }) => ({ value: filename, label: filename }));

const useFilterByFilenameOptions = (fileFormat: FileFormat, switchIncludeAll: boolean) => {
    const availableFilenames = useSelector(getAvailableFilenames);
    const fileFormats = useSelector(getFileFormats);
    const projectType = useSelector(getProjectType);

    const platform = findPlatform(fileFormats, fileFormat);

    return prepareOption({
        availableFilenames,
        projectType,
        platform,
        fileFormat,
        switchIncludeAll,
    });
};

export default useFilterByFilenameOptions;
